import React from 'react'
import './mobile.css'

function Mobile({isOpen,setIsOpen}) {
    return (
        <div className = 'mobile'>
            <div className='close-icon' onClick={()=>setIsOpen(!isOpen)}>
                <img src='/icon6.png' className='close-iconz'></img>
            </div>
            <div className='mobile-options'>

                <div className='mobile-option' onClick={()=>setIsOpen(!isOpen)}>
                    <a href='#projects'>
                        <img src='/icon2.png' className='option-icon'></img>Projects
                    </a>
                </div>
                <div className='mobile-option' onClick={()=>setIsOpen(!isOpen)}>
                <a href='#skills'>
                        <img src='/icon3.png' className='option-icon'></img>Skills
                    </a>
                </div>
                <div className='mobile-option' onClick={()=>setIsOpen(!isOpen)}>
                    <a href='#work'>
                        <img src='/icon4.png' className='option-icon'></img>Work
                    </a>
                </div>
                <div className='mobile-option' onClick={()=>setIsOpen(!isOpen)}>
                    <a href='https://drive.google.com/file/d/175ad9u99X6Nd-gf7_3s0OBgpQ7ywgMDA/view?usp=share_link'>
                        <img src='/icon4.png' className='option-icon'></img>Transcript
                    </a>
                </div>
                <div className='mobile-option' onClick={()=>setIsOpen(!isOpen)}>
                    <a href='#contact'>
                        <img src='/icon5.png' className='option-icon'></img>Contact
                    </a>
                </div>

            </div>
        </div>
    )
}

export default Mobile
